import "./Table.scss";

import { DataGrid } from "@mui/x-data-grid";
import React, { FunctionComponent } from "react";
import { ICustomFooter, ICustomToolbar, TableProps } from "./ITable";
import CustomToolbar from "./components/CustomToolbar";
import CustomFooter from "./components/CustomFooter";
import { ReactComponent as Search } from '../../Assets/Images/search.svg';

const Table: FunctionComponent<TableProps> = (props) => {
  const {
    rows,
    columns,
    autoHeight,
    density,
    loading,
    columnVisibilityModel,
    disableColumnMenu,
    checkboxSelection,
    getRowId,
    rowCount,
    rowHeight,
    children,
    initialPageSize,
    pageSizeOptions,
    localeText,
    sx = {
      // boxShadow: " 0px 12px 24px -4px rgba(145, 158, 171, 0.12)",

      boxShadow: "0px 0px 2px 0px rgba(145, 158, 171, 0.2)",

      borderRadius: "16px",
      // Neutralize the hover colour (causing a flash)
      "& .MuiDataGrid-row.Mui-hovered": {
        backgroundColor: "transparent",
      },
      // Take out the hover colour
      "& .MuiDataGrid-row:hover": {
        backgroundColor: "transparent",
      },
    },
  } = props;

  //    Clasify the child
  const customToolbar = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === CustomToolbar
  );

  const customFooter = React.Children.toArray(children).find(
    (child) => React.isValidElement(child) && child.type === CustomFooter
  );

  //    Access the props of the component
  const customToolbarProps: ICustomToolbar | {} =
    React.isValidElement(customToolbar) && customToolbar.props
      ? (customToolbar.props as ICustomToolbar)
      : {};

  const customFooterProps: ICustomFooter | {} =
    React.isValidElement(customFooter) && customFooter.props
      ? (customFooter.props as ICustomFooter)
      : {};

  return (
    <DataGrid
      localeText={{
        ...localeText,
        toolbarExport: "Download",
        toolbarExportCSV: "CSV",
        toolbarQuickFilterPlaceholder: "Search",
      }}
      disableRowSelectionOnClick
      className="Table"
      sx={sx}
      rows={rows}
      columns={columns}
      autoHeight={autoHeight}
      loading={loading}
      density={density ?? "standard"}
      disableColumnMenu={disableColumnMenu ?? true}
      checkboxSelection={checkboxSelection}
      getRowId={getRowId}
      rowCount={rowCount} // backend total count
      rowHeight={rowHeight}
      getRowHeight={() => "auto"}
      slots={{
        toolbar: customToolbar ? CustomToolbar : undefined,
        footer: customFooter ? CustomFooter : undefined,
        quickFilterIcon: Search,
      }}
      slotProps={{
        toolbar: {
          ...customToolbarProps,
          exportButton: true,
          exportCsv: {
            text: "CSV",
          },
        },
        footer: customFooterProps,
      }}
      pagination
      paginationMode={rowCount ? "server" : "client"} // 🔑
      sortingMode={rowCount ? "server" : "client"}
      pageSizeOptions={pageSizeOptions ?? [10, 25, 50, 100]}
      onPaginationModelChange={(model) => {
        if (props.onPageChange) {
          props.onPageChange(model.page, model.pageSize);
        }
      }}
      onSortModelChange={(model) => {
        if (props.onSortChange) {
          // model = [{ field: "email", sort: "asc" }]
          const sort = model[0] || {};
          props.onSortChange(sort.field, sort.sort);
        }
      }}
      initialState={{
        pagination: { paginationModel: { pageSize: initialPageSize ?? 25 } },
        columns: {
          columnVisibilityModel: columnVisibilityModel,
        },
      }}
    />
  );
};

export default Table;
